import React, { useContext } from 'react';
import { Container, Row, Col, Card, CardImg, CardBody, Button, CardText, CardTitle, Badge } from 'reactstrap';
import Slider from 'react-slick';
import EventImage from '../../assetss/img/event.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle, faBrain, faHandsHolding, faChalkboardTeacher, faLightbulb, faBook, faCalendar, faLaptop, faMapMarkerAlt, faUser, faUserAltSlash, faCalendarAlt, faWifi, faClock, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { CommonContext } from '../../context';
import moment from 'moment';
import CalenderIcon from "../../assetss/img/calender.svg";
import LocationIcon from "../../assetss/img/location.svg";
import E1 from "../../assetss/img/e1.png";
import E2 from "../../assetss/img/e2.png";
import E3 from "../../assetss/img/e3.webp";
import E4 from "../../assetss/img/e4.webp";
const PopularEvents = () => {
    const { indexData } = useContext(CommonContext);
    const navigate = useNavigate();

    const formatStatus = (eventEndDate) => {
        const today = new Date();
        const endDate = new Date(eventEndDate);
        return endDate >= today ? "Upcoming" : "Past";
    };

    const getEventTypeIcon = (eventType) => {
        return eventType === "remote" ? faLaptop : faMapMarkerAlt;
    };
    const getEventStatusIcon = (eventType) => {
        return eventType === "Upcoming" ? faUser : faUserAltSlash;
    };

    const settings = {
        dots: true,
        infinite: indexData?.events?.length > 3,
        speed: 500,
        slidesToShow: indexData?.events?.length > 3 ? 3 : indexData?.events?.length,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: indexData?.events?.length > 2 ? 2 : indexData?.events?.length,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: indexData?.events?.length > 1 ? 1 : indexData?.events?.length,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const goToDetails = (post) => {
        const eventSlug = post?.event_name
            ?.trim()
            .replace(/[^a-zA-Z0-9\s]/g, '')
            .replace(/\s+/g, '-')
            .toLowerCase();

        const stateParam = btoa(JSON.stringify({ id: post?.id }));

        const url = `/event-details/${eventSlug}?state=${stateParam}`;
        navigate(url);
    };
    return (
        <section className="popular-events">
            <Container>
                <Row className="text-center mb-4">
                    <Col md="12">
                        {/* <div className="line"><span>UPCOMING EVENTS</span></div> */}
                        <h2 className="newsletter-title">Explore Our <span className="highlight"> Event</span></h2>
                        <p className="newsletter-text">
                            {/* Physical Seminar - Urban Valuation Conclave "Elevating Valuation Excellence" */}
                        </p>
                    </Col>
                </Row>
                <Slider {...settings}>
                    {indexData?.events?.length > 0 && indexData?.events.map((post, index) => (
                        <Col className="post-card-col" key={index}>
                            <Card className="post-card"
                            //  onClick={() => goToDetails(post)}
                            >
                                <div className="image-wrapper">
                                    <CardImg
                                        top
                                        src={post.image ? `${process.env.REACT_APP_BASE_URL}download/${post?.image}?pathName=events` : "https://via.placeholder.com/150"}
                                        alt="Event cover"
                                        className="post-card-img"
                                    />
                                </div>
                                <CardBody>
                                    {/* <div className="event-info">
                                        <p className="event-date">
                                            <img src={CalenderIcon} alt="Calender" /> {post?.event_start_date ?? "N/A"}
                                        </p>
                                        <div className="event-divider" />
                                        <p className="event-location">
                                            <img src={LocationIcon} alt="Calender" />
                                            {post?.event_type === "online" ? "Online" : `${post?.event_city ?? "N/A"}, ${post?.event_state ?? "N/A"}`}
                                        </p>
                                    </div>
                                    <CardTitle className="post-card-title">{post?.event_name}</CardTitle>
                                    <CardText className="post-card-text">{post?.short_desc}</CardText>
                                    <div className="badge-wrapper">
                                        {post?.event_type && (
                                            <Badge className="category-badge" color={post?.event_type === 'online' ? '' : ''}>
                                                <img src={post?.event_type === 'online' ? E3 : E4} alt={post?.event_type} /> {post?.event_type}
                                            </Badge>
                                        )}
                                        {post?.event_end_date && (
                                            <Badge className={`status-badge ${formatStatus(post?.event_end_date) === 'Upcoming' ? 'upcoming-event' : ''}`} color="inherit">
                                                <img src={post?.event_end_date === 'Upcoming' ? E1 : E2} alt={formatStatus(post?.event_end_date)} />
                                                {formatStatus(post?.event_end_date) === 'Upcoming' ? 'Upcoming' : 'Past'}
                                            </Badge>
                                        )}
                                    </div> */}
                                    <div className="webinar-card">
                                        {/* Background Circle Decorations */}
                                        <div className="circle circle-1"></div>
                                        <div className="circle circle-2"></div>

                                        {/* Top Badges */}
                                        <div className="status-row">
                                            <Badge className="custom-badge online">
                                                <FontAwesomeIcon icon={post?.event_type === 'online' ? faWifi : faMapMarkerAlt} className="badge-icon" />
                                                {post?.event_type}
                                            </Badge>
                                            <Badge className={`custom-badge ${formatStatus(post?.event_end_date) === 'Upcoming' ? 'upcoming' : 'past'}`}>
                                                <FontAwesomeIcon icon={faClock} className={`badge-icon`} />
                                                {formatStatus(post?.event_end_date) === 'Upcoming' ? 'Upcoming' : 'Past'}
                                            </Badge>
                                        </div>

                                        {/* Title and Subtitle */}
                                        <div className="webinar-text">
                                            <h4 className="webinar-title">{post?.event_name}</h4>
                                            <p className="webinar-subtitle">
                                                {post?.short_desc}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="webinar-datetime">
                                        <FontAwesomeIcon icon={faCalendarAlt} className="calendar-icon" />
                                        <div className="datetime-text">
                                            <div className="date">{post?.event_start_date ? moment(post?.event_start_date).format("DD MMMM YYYY") : ""}</div>
                                            {/* <div className="time">{post?.event_start_time ? moment(post?.event_start_time, "HH:mm:ss").format("hh:mm A") : ""} - {post?.event_end_time ? moment(post?.event_end_time, "HH:mm:ss").format("hh:mm A") : ""}</div> */}
                                        </div>
                                    </div>
                                    <div className="register-button-wrapper">
                                        <button className="register-button" onClick={() => goToDetails(post)}>
                                            Register Now <FontAwesomeIcon icon={faArrowRight} className="arrow-icon" />
                                        </button>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Slider>
            </Container>
        </section >
    );
};

export default PopularEvents;
